// Imports
  // Components
  import BannerOfertas from '../components/BannerOfertas'
  import BannerPayment from '../components/BannerPayment'
	import BannerDestacados from '../components/BannerDestacados'
  import BannerCombos from '../components/BannerCombos'




  
// rafce

const Inicio = () => {
  return (
    <>
      <BannerOfertas />
      <BannerPayment />
      <BannerDestacados />
      <BannerCombos />
    </>
  )
}

export default Inicio
